import _ from "lodash"
import { diff } from '../lib/render-object'
import { ChangeProps } from './change-renderer'
import codeService from 'data/codes'

// NB meant for general cases, but some specific mappings exist here when they are the only thing that would be in a custom controls
const mapper = (text) => {
  return {
    folderpath: 'Folder Path',

  }[text] || _.startCase(text)
}

const resource_m = (text) => {
  return {
  }[text] || _.startCase(text)
}

type EventChange = {
  event: string
  data: {
    source: {
      properties: number[]
    }
  }
}

const alwaysDrop = ['externalreference', 'organizationid', 'folderid', 'propertycode', 'propertyid']

export const diffif = (props: ChangeProps) => {
  if (props.method !== 'MARK') return null
  const change = JSON.parse(props.change) as EventChange
  if (!change.event.startsWith('calc')) return null
  return () => {
    const codes = codeService.value().property
    change.data.source.properties = _.map(change.data.source.properties, id => _.find(codes, {id})?.code)
    return {
      atRest: _.startCase(change.event),
      diffs: diff(null, change.data.source, mapper, null, alwaysDrop),
      ...props
    }
  }
}